import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import {ApBaseCVAFormControl} from 'webcommon/core-ui';
import { ApTinyEditorComponent } from 'webcommon/macro';

@Component({
  selector: 'ap-html-text-editor',
  templateUrl: './ap-html-text-editor.component.html',
})

  // Component to use Tiny HTML Editor without Macros.
  // Do not what components to call ap-tiny-editor directly.
export class ApHtmlTextEditorComponent
extends ApBaseCVAFormControl<FormControl<string | null>> {
  @Input() height: number;
  @Input() hideToolbar = true;
  @Input() hideStatusBar = false;
  @Input() editorName: string;
  @Input() displayName: string;
  @Input() setFocusOnInit = true;               // sets the focus when the editor is initialized (useful for modal)
  @Input() setFocusOnInitCursorAtEnd = true;    // when setFocusOnInit is enabled, puts cursor at end of text
  @Input() autoResize = false;
  @Input() autoResizeMaxHeight: number | null = null;
  @Input() autoResizeMinHeight: number | null = null;
  @Output() dirtyChanged: EventEmitter<void> = new EventEmitter();
  @Output() htmlContentChanged = new EventEmitter<string | null>();
  @Output() textContentChanged = new EventEmitter<string>();

  @ViewChild('apTinyEditor') apTinyEditor: ApTinyEditorComponent;

  onEditorValueChanged(value: string | null) {
    // Should only use one of htmlContentChanged or textContentChanged at most
    // Text is assumed to be in html as this is an HTML Editor.
    // Prefer using getContents instead when edit is done (on save or close)
    this.htmlContentChanged.emit(value);
    }

  onEditorValueChangedTextOnly(value: string) {
    // Should only use one of htmlContentChanged or textContentChanged at most
    // Text is assumed to be in html as this is an HTML Editor.
    // Prefer using getContents instead when edit is done (on save or close)
    this.textContentChanged.emit(value);
  }

  public setFocus() {
    this.apTinyEditor.setFocus();
  }

  onDirtyChanged() {
    this.dirtyChanged.emit();
  }

  public getContent(): string {
    return this.apTinyEditor.getContent();
  }

  public getContentsText(): string {
    return this.apTinyEditor.getContentAsText();
  }
}
